

var _angular = require('angular');

var _checkout = require('xo-models/src/checkout');

try {
    var token = window.meta.token;

    _angular.$q.all([_checkout.$CheckoutAppDataModel.instance(token).retrieve(), _checkout.$CheckoutCartModel.instance(token).retrieve()]).then(function (_ref) {
        var appData = _ref[0],
            cart = _ref[1];

        if (appData.is_wps_flow()) {
            window.fptiProductOverride = 'wps';
        } else if (cart.isBilling()) {
            window.fptiProductOverride = 'billing';
        }
    })['catch'](function (e) {
        console.error(e);
    });
} catch (e) {
    console.error(e);
}

_angular.$q;

_checkout.$CheckoutAppDataModel;

_checkout.$CheckoutCartModel;


//////////////////
// WEBPACK FOOTER
// ./js/lib/cplIntegration.js
// module id = ./js/lib/cplIntegration.js
// module chunks = 0